import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var ElectricCircuit = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.533 29.764-2.52-15.213-1.542 9.243a2 2 0 0 1-1.973 1.671H7.874a4.001 4.001 0 0 1-7.874-1 4.001 4.001 0 0 1 7.874-1.001h3.624l1.543-9.242c.372-2.23 3.576-2.229 3.945.002l2.52 15.213 3.478-13.497c.544-2.109 3.586-1.955 3.914.197l2.03 13.311 2.013-5.116a2 2 0 0 1 1.86-1.268h3.45a4.002 4.002 0 1 1-.206 2h-3.243l-2.012 5.117c-.749 1.902-3.53 1.59-3.838-.431L24.92 16.44l-3.478 13.496c-.54 2.095-3.556 1.962-3.91-.172ZM6 24.464a2 2 0 1 0-4.001 0 2 2 0 0 0 4.001 0Zm34-2a2 2 0 1 0 .001 4 2 2 0 0 0-.001-4Z"
  }));
});
ElectricCircuit.displayName = 'ElectricCircuit';
ElectricCircuit.defaultProps = {
  'aria-label': 'ElectricCircuit'
};
export default ElectricCircuit;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/ElectricCircuit.js
// module id = 3775
// module chunks = 11